import React from 'react';
import { NavLink } from 'react-router-dom';
import './PageNav.scss';

const PageNav = ({ heading, links }) => (
  <nav className="PageNav">
    {heading && <h1 className="PageNav-Heading">{heading}</h1>}

    {links.map((l, i) => (
      <React.Fragment key={i}>
        {l.heading && <h1 className="PageNav-GroupHeading">{l.heading}</h1>}
        <NavLink to={l.uri} className="PageNav-Item">
          {l.text}
        </NavLink>
      </React.Fragment>
    ))}
  </nav>
);

export default PageNav;
